module.exports = __webpack_public_path__ + "static/img/2_12.fb0f6e77.jpg";